var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBackToLoginIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21865 4.99999L5.51865 8.29999L4.57598 9.24266L0.333313 4.99999L4.57598 0.757324L5.51865 1.69999L2.21865 4.99999Z",
    fill: "#2B4F7C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackToLoginIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/backToLoginIcon.844cf827.svg";
export { ForwardRef as ReactComponent };